import React from 'react'
import { Card, CardBody } from "reactstrap";
import { TEXT_ADDRESS, TEXT_CONTRACT_VALIDITY_DATE, TEXT_CURRENT_EMPLOYMENT, TEXT_DATE_OF_EMPLOYMENT, TEXT_NAME_OF_EMPLOYER, TEXT_PHONE_NO, TEXT_POSITION } from '../../Text';
import moment from "moment"

const CurrentEmployment = ({ dataSource }) => {
    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <h4 className="card-title">{TEXT_CURRENT_EMPLOYMENT}</h4>
                    <dl className="row mb-0">
                        <dt className="col-sm-3">{TEXT_NAME_OF_EMPLOYER}</dt>
                        <dd className="col-sm-9">{!dataSource.current_employment ? "-" : !dataSource.current_employment.name_of_employer ? "-" : dataSource.current_employment.name_of_employer}</dd>
                        <dt className="col-sm-3">{TEXT_ADDRESS}</dt>
                        <dd className="col-sm-9">{!dataSource.current_employment ? "-" :
                            `${!dataSource.current_employment.address ? "" : dataSource.current_employment.address.address_line_1} 
                                    ${!dataSource.current_employment.address ? "" : dataSource.current_employment.address.address_line_2 + ","}
                                    ${!dataSource.current_employment.address ? "" : dataSource.current_employment.address.city + ","}
                                    ${!dataSource.current_employment.address ? "" : dataSource.current_employment.address.zipcode + ","}
                                    ${!dataSource.current_employment.address ? "" : dataSource.current_employment.address.country}`
                        }</dd>
                        <dt className="col-sm-3">{TEXT_DATE_OF_EMPLOYMENT}</dt>
                        <dd className="col-sm-9">{!dataSource.current_employment ? "-" : !dataSource.current_employment.date_of_employment ? "-" : moment(dataSource.current_employment.date_of_employment).format('LLLL')}</dd>
                        <dt className="col-sm-3">{TEXT_POSITION}</dt>
                        <dd className="col-sm-9">{!dataSource.current_employment ? "-" : !dataSource.current_employment.position ? "-" : dataSource.current_employment.position}</dd>
                        <dt className="col-sm-3">{TEXT_CONTRACT_VALIDITY_DATE}</dt>
                        <dd className="col-sm-9">{!dataSource.current_employment ? "-" : !dataSource.current_employment.contract_validity_date ? "-" : dataSource.current_employment.contract_validity_date}</dd>
                        <dt className="col-sm-3">{TEXT_PHONE_NO}</dt>
                        <dd className="col-sm-9">{!dataSource.current_employment ? "-" : !dataSource.current_employment.phone_number ? "-" : dataSource.current_employment.phone_number}</dd>
                    </dl>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default CurrentEmployment
